import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import { CLIENTS_QUERY_KEY } from "@/hooks/queries/useListClients";
import type { CreateClientRequest, CreatedClientData } from "@/hooks/queries/client-types";

// Create a client (Story 5.1). On success, invalidate every clients query so the
// list refetches and the new (masked) client appears. The response is PHI-free —
// names/DOB are never echoed back, so there is nothing sensitive to cache here.
//
// `skipAuthRefresh` is OMITTED — this is a post-session data call that rides the
// silent-refresh path.

export function useCreateClient() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateClientRequest) =>
      apiFetch<CreatedClientData>("/clients/create", { method: "POST", body }),
    onSuccess: () => {
      // Prefix match: invalidates ["clients", {…}] for every page/filter combination.
      void queryClient.invalidateQueries({ queryKey: [CLIENTS_QUERY_KEY] });
    },
  });
}
